import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/LegalPages.css';

const AccountDeletion = () => {
    const navigate = useNavigate();
    return (
        <div className="legal-page">
            <button className="legal-back-btn" onClick={() => navigate(-1)}>
                &larr; Back
            </button>
            <div className="glass-panel">
                <h1>Remove User Account</h1>
                <p className="effective-date">Want to delete your account?</p>

                <p>If you wish to permanently delete your <strong>Muthu&Co HRMS</strong> account, please send an email to the address below using your registered email address or registered mobile number. Please include the reason for requesting account deletion.</p>

                <h2>1. Submit Your Request</h2>
                <p>Send an email to <a href="mailto:p2pswap786@gmail.com">p2pswap786@gmail.com</a> with the subject "Account Deletion Request". Please include the following details:</p>
                <ul>
                    <li>Full Name</li>
                    <li>Employee ID (if applicable)</li>
                    <li>Registered Mobile Number</li>
                    <li>Registered Email Address</li>
                    <li>Reason for Account Deletion</li>
                </ul>

                <h2>2. Identity Verification</h2>
                <p>Our support team will verify your identity using the information provided. You may be contacted for additional verification if required. Verification is usually completed within 2 business days.</p>

                <h2>3. Account Deletion</h2>
                <p>Once your identity has been verified, your account deletion request will be processed. Your account and associated personal information will be permanently deleted within 7 business days, unless retention is required by applicable law or company policy.</p>

                <h2>Important Notice</h2>
                <ul>
                    <li>Account deletion is permanent and irreversible.</li>
                    <li>Once deleted, your account cannot be restored.</li>
                    <li>Employment, attendance, or work-related records legally required to be retained may be preserved.</li>
                    <li>Any remaining personal information not legally required will be permanently removed.</li>
                </ul>

                <div className="legal-contact-box">
                    <strong>Company:</strong> Muthu & Co<br />
                    <strong>Application:</strong> Muthu&Co HRMS<br />
                    <strong>Email:</strong> <a href="mailto:p2pswap786@gmail.com">p2pswap786@gmail.com</a>
                </div>
            </div>
        </div>
    );
};

export default AccountDeletion;